module.exports = __webpack_public_path__ + "static/win-bigly-01b2b416fb8a743b3bf0633b20e6c22c.jpg";